import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const checkClassName = (variant = 'primary') => {
  const variants = {
    primary: 'primary-btn',
    secondary: 'secondary-btn',
    tertiary: 'tertiary-btn',
    anchor: 'anchor-btn',
    playerPlus: 'player-plus',
    playerPlusBanner: 'player-plus-banner',
    outOfRegion: 'out-of-region',
    svodExclusive: 'svod-exclusive',
  }
  return variants[variant]
}

const Button = React.forwardRef(
  ({
    className,
    handleClick,
    href,
    icon,
    text,
    variant,
    capitalize,
    myListTVGuide,
    ...attrs
  }, ref) => {
    const Element = href ? 'a' : 'button'
    const [mouseFocus, setMouseFocus] = useState(false)
    const [touchable, setTouchable] = useState(false)

    useEffect(() => {
    // ignore devices' fake hover state by setting additional class if we detect a touch interaction
      const handleTouch = () => {
        setTouchable(true)
        window.removeEventListener('touchstart', handleTouch, false)
      }
      window.addEventListener('touchstart', handleTouch, false)
      return () => window.removeEventListener('touchstart', handleTouch)
    }, [])

    const classNames = [
      'Button',
      checkClassName(variant),
      capitalize && 'capitalize',
      mouseFocus && 'no-focus',
      touchable && 'touchable',
      className,
    ]
      .filter(Boolean)
      .join(' ')

    const handleBlur = () => {
      setMouseFocus(false)
    }

    const clickWithFocus = () => {
      setMouseFocus(true)
      handleClick()
    }

    const buttonType = Element === 'button' ? { type: 'button' } : {}

    return (
      <Element
        {...buttonType}
        href={href}
        onClick={clickWithFocus}
        onBlur={handleBlur}
        className={classNames}
        ref={ref}
        {...attrs}
      >
        { icon && (<span className={`icon-wrap ${myListTVGuide ? 'tv-guide' : ''}`}> {icon} </span>) }
        {text}
        <style jsx>{styles}</style>
      </Element>
    )
  }
)

Button.propTypes = {
  handleClick: PropTypes.func,
  icon: PropTypes.node,
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'anchor', 'playerPlus', 'outOfRegion', 'playerPlusBanner', '']),
  capitalize: PropTypes.bool,
  href: PropTypes.string,
  className: PropTypes.string,
  myListTVGuide: PropTypes.bool,
}
Button.defaultProps = {
  handleClick: () => {},
  icon: null,
  variant: 'primary',
  capitalize: false,
  href: null,
  className: '',
  myListTVGuide: false,
}

export default Button
